export default __webpack_public_path__ + "static/media/media_pause.c3664c01.svg";